import { render, staticRenderFns } from "./MedicalImageView.vue?vue&type=template&id=6b59272e&scoped=true&"
import script from "./MedicalImageView.vue?vue&type=script&lang=js&"
export * from "./MedicalImageView.vue?vue&type=script&lang=js&"
import style0 from "./MedicalImageView.vue?vue&type=style&index=0&id=6b59272e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b59272e",
  null
  
)

export default component.exports